module.exports = __webpack_public_path__ + "img/linkedin.526503e1.svg";